import { render, staticRenderFns } from "./CalendarDashboard.vue?vue&type=template&id=bd526b66&scoped=true"
import script from "./CalendarDashboard.vue?vue&type=script&lang=js"
export * from "./CalendarDashboard.vue?vue&type=script&lang=js"
import style0 from "./CalendarDashboard.vue?vue&type=style&index=0&id=bd526b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd526b66",
  null
  
)

export default component.exports